"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Primitive {
    constructor(props) {
        const { type, name, label = undefined, columnSize = undefined, settings = undefined, required = undefined, readonly = undefined, disabled = undefined, helperText = undefined, defaultColumn = undefined, pattern = undefined, defaultValue = undefined, ident = undefined, watch = undefined, inlinePatch = undefined, unversioned = undefined, hidden = undefined, hideFromColumns = undefined, hideFromSegmentation = undefined, options = undefined, dynOptions = undefined, min = undefined, max = undefined, react = undefined, virtual = undefined, visibleIf = undefined, } = props;
        this.name = name;
        this.label = label;
        this.type = type.toLowerCase();
        this.columnSize = columnSize;
        this.required = required;
        this.readonly = readonly;
        this.helperText = helperText;
        this.disabled = disabled;
        this.defaultColumn = defaultColumn;
        this.pattern = pattern;
        this.settings = settings || {};
        this.min = min;
        this.max = max;
        this.ident = ident;
        this.watch = watch;
        this.inlinePatch = inlinePatch;
        this.unversioned = unversioned;
        this.hidden = hidden;
        this.hideFromColumns = hideFromColumns;
        this.hideFromSegmentation = hideFromSegmentation;
        this.dynOptions = dynOptions;
        this.virtual = virtual;
        this.visibleIf = visibleIf;
        this.react = react;
        if (options !== undefined) {
            this.options = options.map((o) => {
                if (typeof o === 'string') {
                    let value = settings && settings.variant === 'icon' ? o : o.replace(/([^a-z0-9.\-\/\+_]+)/gi, '');
                    if (!settings || !settings.acceptUpperCase)
                        value = value.toLowerCase();
                    return {
                        label: o,
                        value,
                    };
                }
                return o;
            });
        }
        this.setDefaults();
        if (defaultValue !== undefined) {
            this.defaultValue = defaultValue;
        }
    }
    get isReference() {
        return false;
    }
    get referenceModel() {
        throw new Error('Method not implemented → referenceModel');
    }
    setDefaults() { }
    async modifyStructure(entity) { }
    modify(val) {
        return val;
    }
    modifySimple(val) {
        return val;
    }
    modifyBson(val) {
        return val;
    }
    validate(val) {
        return true;
    }
    modifyExport(val, exObj) {
        return val;
    }
}
exports.default = Primitive;
